export const API_HOST = process.env.REACT_APP_API_HOST;
export const JWT_SECRET = process.env.REACT_APP_JWT_SECRET;
